export const QUERY_CATEGORIZATION_EXPERIMENT = 'product_search_query_categorization';
export const QUERY_CATEGORIZATION_EXPERIMENT_VARIATION = 'test';
export const ENABLED_AB_TEST_FEATURES = {
  [QUERY_CATEGORIZATION_EXPERIMENT]: {
    variation: QUERY_CATEGORIZATION_EXPERIMENT_VARIATION
  }
};
